import React, { useState, useRef, useEffect } from "react";
import "./EsimHeaderCard.css";
import { Edit3, MoreVertical, Share2, Archive } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

const EsimHeaderCard = ({ iccid, region, imageUrl, label, recipient, onEdit, onShareEmail, onArchiveEsim }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const { t } = useLanguage();

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="esim-header-card">
            <div className="image-block">
                <img src={imageUrl} alt={`eSIM ${region.name}`}/>

                {/* Title + pencil */}
                <h2 className="esim-header-card-title">
                    {label}
                    <button
                        className="header-edit-btn"
                        onClick={onEdit}
                        aria-label={t("esimLegacy.renameAria")}
                    >
                        <Edit3 size={18}/>
                    </button>
                </h2>

                {/* 3-dots menu */}
                <div
                    className="menu-wrapper"
                    ref={menuRef}
                >
                    <MoreVertical
                        className="menu-icon"
                        size={22}
                        onClick={() => setMenuOpen(o => !o)}
                        aria-haspopup="menu"
                        aria-expanded={menuOpen}
                        aria-label={t("esimLegacy.menuAria")}
                    />

                    {menuOpen && (
                        <div
                            className="menu-dropdown"
                            role="menu"
                            tabIndex={-1}
                            onKeyDown={(e) => {
                                if (e.key === "Escape") setMenuOpen(false);
                            }}
                        >
                            <button
                                className="menu-item"
                                role="menuitem"
                                onClick={() => {
                                    setMenuOpen(false);
                                    onEdit();
                                }}
                            >
                                <span className="menu-icon-wrap">
                                  <Edit3 size={16}/>
                                </span>
                                <span>{t("esimLegacy.rename")}</span>
                            </button>

                            <div className="menu-sep"/>

                            <button
                                className="menu-item"
                                role="menuitem"
                                onClick={() => {
                                    setMenuOpen(false);
                                    onShareEmail();
                                }}
                            >
                                <span className="menu-icon-wrap">
                                  {/* Share2 or Mail—email feels clearer */}
                                    <Share2 size={16}/>
                                </span>
                                <span>{t("esimLegacy.shareEmail")}</span>
                            </button>

                            <div className="menu-sep"/>

                            <button
                                className="menu-item"
                                role="menuitem"
                                onClick={() => {
                                    setMenuOpen(false);
                                    onArchiveEsim && onArchiveEsim();
                                }}
                            >
                                <span className="menu-icon-wrap">
                                    <Archive size={16}/>
                                </span>
                                <span>{t("esimLegacy.archive")}</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>


            <div className="info-block">
                <p>
                    <span className="label">ICCID</span><br/>
                    {iccid}
                </p>
                <p>
                    <span className="label">{t("esimLegacy.country")}</span><br/>
                    {region.coverage}
                </p>
                {recipient && (
                    <p>
                        <span className="label">{t("esimLegacy.sharedWith")}</span><br/>
                        {recipient}
                    </p>
                )}
            </div>
        </div>
    );
};

export default EsimHeaderCard;
